// removed by extract-text-webpack-plugin
module.exports = {"message":"c-FieldMessage__message","error":"c-FieldMessage__error"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/FieldMessage/FieldMessage.scss
// module id = 849
// module chunks = 0